import * as React from 'react';
import '../../Calendar.css';
import cn from 'classnames';
import { BooksWithParsedDates } from '../../Calendar';
import { isWithinInterval, isSameMonth, isSameYear, getMonth } from 'date-fns';
import { Month as MonthType } from '../../Calendar';
import { localedFormat, MOBILE_MAX_WIDTH, getDatePeriod } from '../../../../utils';
import { CardType, LibraryCard } from '../../../../types/LibraryCard';
import Dialog from '@material-ui/core/Dialog';
import BookChip from '../../../BookCalendar/BooksSidebar/BookChip/BookChip';
import HeightControl from '../../HeightControl/HeightControl';
import BookCardWrapper from '../../../BookCalendar/BookCardWrapper/BookCardWrapper';
import MediaQuery from 'react-responsive';
import MobileBookCard from '../../../BookCalendar/MobileCalendar/MobileBookCard/MobileBookCard';
import './Month.css';
import Drawer from '@material-ui/core/Drawer/Drawer';
import MonthModal from './MonthModal/MonthModal';

interface Props {
	month: MonthType;
	books?: BooksWithParsedDates[];
}

const Month: React.FunctionComponent<Props> = props => {
	const [selectedCard, setSelectedCard] = React.useState<LibraryCard>(null);
	const [openedMonth, setOpenMonth] = React.useState(false);

	React.useEffect(() => {
		if (selectedCard) {
			setSelectedCard(props.month.cards.find(card => selectedCard.eId === card.card.eId)?.card);
		}
	}, [props.month]);

	return (
		<div
			className={cn("day", "month", {
				month_empty: props.month.cards.length === 0,
				day_fromOtherMonth: false,
				day_current:
					isSameMonth(props.month.startOfMonth, new Date()) &&
					isSameYear(props.month.startOfMonth, new Date()),
			})}
		>
			<div className="day__inside" onClick={() => setOpenMonth(true)}>
				<div className="day__monthName">
					{localedFormat(props.month.startOfMonth, "LLLL")}

					{props.month.cards.length > 0 && (
						<div className="day__count">{props.month.cards.length}</div>
					)}
				</div>
			</div>

			{props.month.cards.length > 0 && (
				<div className="day__books">
					<HeightControl
						showMore={<div className="day__showMore">Показать все</div>}
						header={`Книги ${localedFormat(props.month.startOfMonth, "MMMM")}`}
						onClickMore={() => setOpenMonth(true)}
					>
						{props.month.cards.map((card) => {
							return (
								<BookChip
									key={card.card.eId}
									card={card.card}
									customPeriod={getDatePeriod(
										card.startDate,
										card.endDate,
										"c ",
										" по ",
										card.type === CardType.WantRead
									)}
									onClick={() => {
										setSelectedCard(card.card);
									}}
									className="day__book"
								/>
							);
						})}
					</HeightControl>
				</div>
			)}

			<Drawer
				anchor="right"
				open={openedMonth}
				onClose={() => setOpenMonth(false)}
			>
				<MonthModal month={props.month} setSelectedCard={setSelectedCard} />
			</Drawer>

			<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
				<Dialog
					open={!!selectedCard}
					onClose={() => setSelectedCard(null)}
					maxWidth="xl"
					scroll="body"
					classes={{
						paper: "calendar-book__paper",
					}}
				>
					<div className="calendar-book__wrapper">
						{selectedCard && <BookCardWrapper libraryCard={selectedCard} />}
					</div>
				</Dialog>
			</MediaQuery>

			<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
				<Dialog
					fullScreen={true}
					open={!!selectedCard}
					onClose={() => setSelectedCard(null)}
					classes={{
						root: "mobile-book-card",
					}}
				>
					<>
						{selectedCard && (
							<MobileBookCard
								card={selectedCard}
								onClose={() => setSelectedCard(null)}
							/>
						)}
					</>
				</Dialog>
			</MediaQuery>
		</div>
	);
};

export default Month;